const NODE_ENV = process.env.REACT_APP_ENVTYPE;
const BASE_URL = process.env.REACT_APP_NODEURL;
const OrigineRoute = window.location.origin;

console.log("Query Check On API Config autobuild on >>>> ", OrigineRoute, BASE_URL);

export default {
  baseURL: BASE_URL,
  auth: "auth/",
  secure: "secure/",
  NODE_ENV: NODE_ENV,
  APPLICATION_URL: OrigineRoute,
};
